/**
 * Enums required by the Er diagram and are associated to the current ActionState
 */

export const ACTIONSTATE = {
    Default: "Default",
    AddConnection: "AddConnection",
}

export const ConnectionCardinality = {
    Min: "Min",
    Max: "Max"
}

export const OBJECTTYPE = {
    Connection: "Connection",
    DrawBoardElement: "DrawBoardElement"
}